import React from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { useLang } from "@/context/LangContext";
import {
  Users2, Globe, Server, Link2, LineChart, Search, Store, CreditCard,
  Smartphone, HardHat, Wallet, MapPin, FolderKanban, Package, Receipt, Zap, Sparkles, Cpu
} from "lucide-react";

const MODULES = [
  { key: "crm", name: "CRM", icon: Users2 },
  { key: "websites", name: "Websites", icon: Globe },
  { key: "hosting", name: "Hosting", icon: Server },
  { key: "domains", name: "Domains", icon: Link2 },
  { key: "seo", name: "SEO", icon: Search },
  { key: "google_business", name: "Google Business", icon: MapPin },
  { key: "analytics", name: "Analytics", icon: LineChart },
  { key: "search_console", name: "Search Console", icon: Search },
  { key: "ai", name: "AI", icon: Sparkles },
  { key: "marketplace", name: "Marketplace", icon: Store },
  { key: "nfc_cards", name: "NFC Cards", icon: CreditCard },
  { key: "uniforms", name: "Uniforms", icon: HardHat },
  { key: "mobile_apps", name: "Mobile Apps", icon: Smartphone },
  { key: "employees", name: "Employees", icon: Users2 },
  { key: "payroll", name: "Payroll", icon: Wallet },
  { key: "gps", name: "GPS", icon: MapPin },
  { key: "projects", name: "Projects", icon: FolderKanban },
  { key: "inventory", name: "Inventory", icon: Package },
  { key: "billing", name: "Billing", icon: Receipt },
  { key: "automation", name: "Automation", icon: Zap },
];

export default function Placeholders() {
  const { t } = useLang();
  return (
    <DashboardLayout title={t("future.title")} subtitle={t("future.subtitle")}>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-testid="future-grid">
        {MODULES.map((m) => (
          <div key={m.key} className="rounded-xl border border-dashed border-zinc-800 bg-zinc-900/30 p-5 flex flex-col items-start hover:border-zinc-700" data-testid={`future-${m.key}`}>
            <div className="w-9 h-9 rounded-md bg-zinc-800/60 grid place-items-center mb-3">
              <m.icon className="w-4 h-4 text-zinc-300" />
            </div>
            <div className="font-display text-sm font-semibold text-zinc-100">{m.name}</div>
            <div className="mt-1 text-[10px] uppercase tracking-widest text-zinc-500">Coming soon</div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
